import { InputFilterType } from '@share/common-types';
import { IStatementColumnMenu } from '../pages';
import StatementAction from '../../components/components/company-statement/statementOverview';
const getStatementActions: any = (text: any, record: any , rest : any) => <StatementAction record={record}  />;
export const MyStatementColumnMenu: IStatementColumnMenu[] = [
  {
    description: 'STATUS',
    key: 'paymentStatus',
    width: 120,
    display: true,
    order: 1,
    type: InputFilterType.Text,
    displayConditions: false,
  },
  {
    description: 'INVOICE #',
    key: 'creditLineInvoiceId',
    width: 125,
    display: true,
    order: 2,
    type: InputFilterType.IntegerNumber,
    displayConditions: false,
  },
  {
    description: 'BOOKING #',
    key: 'bookingId',
    width: 128,
    display: true,
    order: 3,
    type: InputFilterType.IntegerNumber,
    displayConditions: false,
    sortable: false,
  },
  {
    description: 'INVOICE TOTAL',
    key: 'amount',
    width: 150,
    display: true,
    order: 4,
    type: InputFilterType.IntegerNumber,
    displayConditions: false,
    bold: true,
  },
  {
    description: 'PAID ON',
    key: 'paidDate',
    // filterFieldName: 'paidDate',
    width: 140,
    incomingDateFormat: 'MM/DD/YYYY',
    display: true,
    order: 5,
    type: InputFilterType.Date,
    displayConditions: false,
  },
  // {
  //   description: 'DEPARTMENT',
  //   key: 'department',
  //   width: 150,
  //   display: true,
  //   order: 6,
  //   type: InputFilterType.IntegerNumber,
  //   displayConditions: false,
  //   bold: true,
  // },
  // {
  //   description: 'TRAVELER',
  //   key: 'traveler',
  //   width: 150,
  //   display: true,
  //   order: 7,
  //   type: InputFilterType.IntegerNumber,
  //   displayConditions: false,
  //   bold: true,
  // },
  {
    description: 'START DATE',
    key: 'created',
    width: 135,
    incomingDateFormat: 'MM/DD/YYYY',
    display: true,
    order: 8,
    type: InputFilterType.Date,
    displayConditions: true,
  },
  {
    description: 'END DATE',
    key: 'paidDate',
    width: 135,
    incomingDateFormat: 'MM/DD/YYYY',
    display: true,
    order: 9,
    type: InputFilterType.Date,
    displayConditions: true,
  },
  {
    description: 'ACTIONS',
    key: 'actions',
    width: 110,
    display: true,
    order: 10,
    type: InputFilterType.Custom,
    component: getStatementActions,
  },
];
